/* eslint-disable
    import/no-mutable-exports,
    no-cond-assign,
    no-return-assign,
    no-var,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import reactUpdate from 'immutability-helper';
import _ from 'underscore';

import * as FileBrowserConstants from 'constants/FileBrowserConstants';
import {FolderPreferences} from 'constants/FolderConstants';
import {StringIDFolder} from 'constants/FolderConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {FinderResult, WorkspaceItem} from 'constants/NavConstants';
import {SourceSummary} from 'constants/SourceConstants';
import preferences from 'Preferences';
import APIUtil from 'util/APIUtil';

function getDefaultSection(isRegistry?: boolean): string {
  let left;
  if (isRegistry == null) {
    isRegistry = false;
  }
  if (isRegistry) {
    return FileBrowserConstants.INVENTORY_SECTION;
  }
  return (left = preferences.get(FolderPreferences.DEFAULT_SECTION)) != null
    ? left
    : FileBrowserConstants.INVENTORY_SECTION;
}

var FinderUtil = {
  sourceToRootFolder(source: SourceSummary): StringIDFolder {
    return reactUpdate(source.rootFolder as StringIDFolder, {
      $merge: {
        id: source.rootFolder.api_identifier,
        source,
      },
    });
  },

  parentFolderId(result: FinderResult): string | undefined {
    switch (APIUtil.apiIdToType(result.id)) {
      case ModelTypeConstants.FOLDER:
        return result.parent != null ? result.parent.api_identifier : undefined;
      default:
        return result.folder.api_identifier;
    }
  },

  /**
   * Finds a folder or folder item in the workspace.
   * @param  {String} itemId         API ID of folder or folder item
   * @param  {Array} workspaceItems  Workspace items to look through
   * @return {Object}                The workspace item, or null if not found
   */
  findInWorkspace(itemId: string, workspaceItems: Array<WorkspaceItem>): WorkspaceItem | undefined {
    // eslint-disable-next-line no-restricted-syntax
    return _.find(workspaceItems, (workspaceItem) => workspaceItem.fileId === itemId);
  },

  getDefaultSection,
};

export default FinderUtil;
